import  firebase from "firebase/app";
import "firebase/auth";

var  Config = {
    apiKey: "AIzaSyB--YCMEW6v8iVlzUeQL0m7_1CheRTzTeY",
    authDomain: "buyandsell-r.firebaseapp.com",
    databaseURL: "https://buyandsell-r.firebaseio.com",
    projectId: "buyandsell-r",
    storageBucket: "buyandsell-r.appspot.com",
    messagingSenderId: "984704461061",
    appId: "1:984704461061:web:37dc0fa1e6b42c931a6f6c",
    measurementId: "G-XRKY15V0KC"
}

firebase.initializeApp(Config);

export default firebase ;

//    var firebaseConfig = {
//        apiKey: "AIzaSyDOCAbC123dEf456GhI789jKl01-MnO",
//        authDomain: "myapp-project-123.firebaseapp.com",
//        databaseURL: "https://myapp-project-123.firebaseio.com",
//        projectId: "myapp-project-123",
//        storageBucket: "myapp-project-123.appspot.com",
//        messagingSenderId: "65211879809",
//        appId: "1:65211879909:web:3ae38ef1cdcb2e01fe5f0c",
//        measurementId: "G-8GSGZQ44ST"
//      };